import ActionType from './action-type'
import {Action} from './actions'
import produce from 'immer'
import {LoggingOutAction} from '../session-data/actions'
import SessionActionType from '../session-data/action-type'

import {DEFAULT_ROLES_STATE, RolesReduxState, UserRole} from './state'
import {getUpdatedDataArray} from '../reducer-helpers'

const rolesReducer = produce(
    (draft: RolesReduxState = DEFAULT_ROLES_STATE, action: Action | LoggingOutAction) => {
        switch (action.type) {
            case ActionType.REQUEST_ROLES_FOR_CURRENT_USER:
                draft.isFetching = true
                break
            case ActionType.RECEIVE_ROLES_FOR_CURRENT_USER:
                draft.isFetching = false
                const {dataUpdated, data} = getUpdatedDataArray<UserRole>(
                    action.payload,
                    draft.userRoles,
                    (a, b) => a.userIdentity === b.userIdentity,
                )
                if (dataUpdated) {
                    draft.userRoles = data
                }
                break

            case SessionActionType.LOGGING_OUT:
                draft = DEFAULT_ROLES_STATE
                break

            /* istanbul ignore next */
            default:
                return draft
        }
        return draft
    },
)
export default rolesReducer
